export const profileTabNames = ["student", "guardian"] as const;
export type ProfileTabName = typeof profileTabNames[number];

export function isProfileTabName(str: string): str is ProfileTabName {
  return profileTabNames.some(v => v === str);
}
